import request from '@/util/http'
import qs from "qs";
export function getListTableUrl(query) {
    return request({
        url: 'admin/user/page',
        method: 'get',
        params: query
    })
}
export function delDataUrl(params) {
    return request({
        url: '/admin/user/batch?' + params,
        method: 'delete',
    })
}

export function finiSchool(params) {
    return request({
        url: '/admin/user/expire',
        method: 'post',
        data:params
    })
}
export function getLock(params) {
    return request({
        url: '/admin/user/lock/'+params,
        method: 'put',
        // data:params
    })
}
export function getUnLock(params) {
    return request({
        url: '/admin/user/unlock/'+params,
        method: 'put',
        // data:params
    })
}
export function validateCodeUrl(params) {
    return request({
        url: "/admin/user/validateCode/" + params,
        method: 'get',
    })
}

export function validateNameUrl(params) {
    return request({
        url: "/admin/user/validateName/" + params,
        method: 'get',
    })
}
export function insertUrl(params) {
    return request({
        url: "/admin/user",
        method: 'POST',
        data: params
    })
}
export function updateUrl(params) {
    return request({
        url: "/admin/user",
        method: 'put',
        data: params
    })
}

export function resetpwdUrl(params) {
    return request({
        url: "/admin/user/resetpwd/batch?" + params,
        method: 'get',
    })
}

export function saveUserManageDeptsUrl(params) {
    return request({
        url: "/admin/user/saveUserManageDepts",
        method: 'POST',
        data: params
    })
}

export function userRolesUrl(params) {
    return request({
        url: "/admin/role/userRoles",
        method: 'get',
        params: params
    })
}

export function arrangeUserRolesUrl(params) {
    return request({
        url: "/admin/role/arrangeUserRoles?" + params,
        method: 'get',
    })
}

export function saveUserRolesUrl(params) {
    return request({
        url: "/admin/role/saveUserRoles",
        method: 'POST',
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: params,

    })
}

// export function studentTreeMenuUrl(params) {
//     return request({
//         url: "/admin/dept/courseDeptTree",
//         method: 'get',
//
//     })
// }